import type { ParametersParameter, Period } from "@medplum/fhirtypes";
import dayjs from "dayjs";

function formatFhirDateTimeForDisplay(iso: string): string {
  const parsed = dayjs(iso);
  if (!parsed.isValid()) {
    return iso;
  }
  return parsed.format("MMM D, YYYY h:mm A");
}

function formatPeriodForDisplay(period: Period): string {
  const start = period.start ? formatFhirDateTimeForDisplay(period.start) : "—";
  const end = period.end ? formatFhirDateTimeForDisplay(period.end) : "—";
  return `${start} – ${end}`;
}

/** Maps FHIR Parameters.value* to a single display string. */
export function formatCareGapParameterValue(param: ParametersParameter): string {
  if (param.valuePeriod) {
    return formatPeriodForDisplay(param.valuePeriod);
  }
  if (param.valueCodeableConcept) {
    const cc = param.valueCodeableConcept;
    if (cc.text) {
      return cc.text;
    }
    const coding = cc.coding?.[0];
    if (coding?.display) {
      return coding.display;
    }
    if (coding?.code) {
      return coding.code;
    }
  }
  if (param.valueCoding) {
    const c = param.valueCoding;
    if (c.display && c.code) {
      return `${c.display} (${c.code})`;
    }
    if (c.display) {
      return c.display;
    }
    if (c.code) {
      return c.code;
    }
  }
  if (param.valueCode) {
    return param.valueCode;
  }
  if (param.valueString) {
    return param.valueString;
  }
  if (param.valueBoolean !== undefined) {
    return String(param.valueBoolean);
  }
  if (param.valueInteger !== undefined) {
    return String(param.valueInteger);
  }
  if (param.valueDecimal !== undefined) {
    return String(param.valueDecimal);
  }
  if (param.valueDate) {
    return param.valueDate;
  }
  if (param.valueDateTime) {
    return formatFhirDateTimeForDisplay(param.valueDateTime);
  }
  if (param.valueUri) {
    return param.valueUri;
  }
  return "—";
}
